import { AmountValue } from 'common/interfaces';
import { AccountStatus, ActiveStatus } from 'enums/index';
import { ForeignIdType } from 'stores/workflowStores/workflowPersonalDataStore/model';
import { DueSeverity } from 'stores/accountsStore';
import { ClientView, Currency, AccountMode, Method2FA, TaxMode, Request, PersonType } from 'enums';

export enum PendingChanges {
  NONE = 'NONE',
  PLAN = 'PLAN',
  WITHDRAWAL = 'WITHDRAWAL',
  FEES = 'FEES',
  PERSONAL = 'PERSONAL_DATA',
  TRANSFER = 'TRANSFER',
  PORTFOLIO = 'PORTFOLIO'
}

interface PendingWithdrawal {
  type: 'REGULAR' | 'ALL' | 'TARGET';
  value: AmountValue;
  title?: string;
  date: string;
}

interface PendingTransfer {
  target: boolean;
  value: AmountValue;
  date: string;
}

export interface AccountSummary {
  accountId: string;
  title: string;
  activeFrom: string;
  closedFrom?: string;
  status: AccountStatus;
  mode: AccountMode;
  activeStatus: ActiveStatus;
  pendingChanges: PendingChanges;
  processing: boolean;
  pendingChangeSignature: boolean;
  pendingRequestSignature: Request[];
  currency: Currency;
  canTerminateContract: boolean;
  pendingWithdrawal?: PendingWithdrawal[];
  pendingTransfer: PendingTransfer[];
  clientTaxMode: TaxMode // EDS-4915
  feePaidAll: boolean;
  profileLockActive: boolean;
}

export interface AccountSummaryData {
  ownerData: {
    companyName: string;
    companyNumber: string;
    contactEmail: string;
    contactPhone: string;
    firstName: string;
    lastName: string;
    personType: PersonType;
    taxResidency: { country: string; };
    personalNumber: string;
    foreignIdType: ForeignIdType;
    foreignId: string;
    reactivationEnabled: boolean;
    changeClientViewEnabled: boolean;
    resetEnabled: boolean;
    clientView: ClientView;
    use2fa: boolean;
    riskProfile?: number;
    retired: boolean;
    method?: Method2FA
  };
  accountsSummary: AccountSummary[];
}

export interface AccountDetailData extends AccountSummary {
  variableSymbol: string;
  balance: AmountValue;
  profit: AmountValue;
  yearlyProfit: number;
  cash: AmountValue;
  feePaid: AmountValue;
  feeTotal: AmountValue;
  feePaidAll: boolean;
  currency: Currency;
  title: string;
  financialQuestionnaireValidityDate: {date: string; severity: DueSeverity }
  investmentQuestionnaireValidityDate: {date: string; severity: DueSeverity }
  riskProfileMismatch?: boolean;
}

export interface AccountData {
  summary: AccountSummaryData | null;
  detail: AccountDetailData | null;
}
